import React from 'react';
import {Dropdown, Grid} from 'semantic-ui-react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import {ISOToDisplayDate, formatDateMMDDYYYY} from 'common/utils';
import {ASSOCIATED_ENTITY_STATUSES} from 'app-ui-componentlibrary/dist/common/constants';

export const RequestsForAssistanceTable = (props) => {
  const {
    rfas,
    selectedColumn,
    sortDirection,
    setSelectedColumnProp,
    setSortDirectionProp,
    summary,
    doEntityAction,
  } = props;
  const columnsToHide = _.get(props, 'hideColumns', []);

  const handleColumnClick = (columnName) => {
    let direction = sortDirection == 'ASC' ? 'DESC' : 'ASC';
    setSelectedColumnProp(columnName);
    setSortDirectionProp(direction);
  };
  const getClassName = (columnName) =>
    `sorted${
      selectedColumn == columnName
        ? sortDirection == 'ASC'
          ? ' ascending'
          : ' descending'
        : ''
    }`;

  const renderActiveTabContents = () => {
    return (
      <Grid key={'rfasGrid'} doubling stackable reversed="mobile" padded="vertically">
        <Grid.Column className="visible-overflow">
          <FemaGoTable
            summary={summary || 'Requests for assistance table'}
            type="static"
            columns="8"
            className="sortable"
          >
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                {!_.includes(columnsToHide, 'orgName') ? (
                  <FemaGoTable.HeaderCell
                    title="Recipient"
                    onClick={() => handleColumnClick('orgName')}
                    className={getClassName('orgName')}
                  >
                    Recipient
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'subOrgName') ? (
                  <FemaGoTable.HeaderCell
                    title="Subrecipient"
                    onClick={() => handleColumnClick('subOrgName')}
                    className={getClassName('subOrgName')}
                  >
                    Subrecipient
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'status') ? (
                  <FemaGoTable.HeaderCell
                    title="Status of request for assistance"
                    onClick={() => handleColumnClick('status')}
                    className={getClassName('status')}
                  >
                    Status
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'statusTimeStamp') ? (
                  <FemaGoTable.HeaderCell
                    title="Date of status"
                    onClick={() => handleColumnClick('statusTimeStamp')}
                    className={getClassName('statusTimeStamp')}
                  >
                    Status date
                  </FemaGoTable.HeaderCell>
                ) : null}
                {!_.includes(columnsToHide, 'actions') ? (
                  <FemaGoTable.HeaderCell title="Actions for request for assistance">
                    Actions
                  </FemaGoTable.HeaderCell>
                ) : null}
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              {_.map(rfas, (rfa) => {
                const actions = _.get(rfa, 'actions', []);
                let showError = false;
                let errorMessages = [];
                let statusTS = formatDateMMDDYYYY(_.get(rfa, 'statusTimestamp'));
                if (!statusTS)
                  statusTS = formatDateMMDDYYYY(
                    ISOToDisplayDate(_.get(rfa, 'statusTimestamp') * 1000),
                    ''
                  );
                return (
                  <FemaGoTable.Row
                    key={`${rfa.entityId}`}
                    errorMessages={errorMessages}
                    displayError={showError}
                  >
                    {!_.includes(columnsToHide, 'orgName') ? (
                      <FemaGoTable.TextCell>
                        {_.get(rfa.payload, 'orgDisplayName')}
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'subOrgName') ? (
                      <FemaGoTable.TextCell>
                        {_.get(rfa.payload, 'subOrgDisplayName')}
                      </FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'status') ? (
                      <FemaGoTable.TextCell>{`${
                        ASSOCIATED_ENTITY_STATUSES[rfa.status]
                      }`}</FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'statusTimeStamp') ? (
                      <FemaGoTable.TextCell>{statusTS}</FemaGoTable.TextCell>
                    ) : null}
                    {!_.includes(columnsToHide, 'actions') ? (
                      <FemaGoTable.TextCell>
                        {!_.isEmpty(actions) ? (
                          <Dropdown
                            selectOnNavigation={false}
                            selectOnBlur={false}
                            text={'Actions'}
                            name={`${rfa.entityId}-action-button`}
                            id={`${rfa.entityId}-action-button`}
                            onChange={(e, {name, value}) => doEntityAction(value, rfa)}
                            options={actions}
                            direction="left"
                            value={''}
                          />
                        ) : null}
                      </FemaGoTable.TextCell>
                    ) : null}
                  </FemaGoTable.Row>
                );
              })}
            </FemaGoTable.Body>
          </FemaGoTable>
        </Grid.Column>
      </Grid>
    );
  };

  return <>{renderActiveTabContents()}</>;
};

export default connectDynamic(RequestsForAssistanceTable);
